import { Flex } from "antd";
import styled from "styled-components";

export const StyledTaskCard = styled(Flex)`
    border-radius: 8px;
    border: 1px solid ${({ theme }) => theme.secondaryBorderColor};
    background: ${({ theme }) => theme.itemBackground};
    padding: 8px 10px;
`;
